import { queryDateRangePicker } from './date-range-picker';
import type { NewsListAjaxUpdateConfig } from './news-list-ajax-update';

function formatResultsCount(count: number): string {
  const mod10 = count % 10;
  const mod100 = count % 100;
  let word: string;

  if (mod10 === 1 && mod100 !== 11) {
    word = 'результат';
  } else if (mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) {
    word = 'результата';
  } else {
    word = 'результатов';
  }

  return `${count} ${word}`;
}

function hasActiveDateRange(root: ParentNode): boolean {
  const range = queryDateRangePicker(root);
  if (!range) return false;

  return Boolean(range.inputFrom.value || range.inputTo.value);
}

export function updateRangeEmptySummary(
  root: ParentNode,
  config: Pick<NewsListAjaxUpdateConfig, 'gridSelector' | 'cardSelector'>,
): void {
  const summary = root.querySelector<HTMLElement>('[data-range-summary]');
  if (!summary) return;

  if (!hasActiveDateRange(root)) {
    summary.hidden = true;
    return;
  }

  const grid = root.querySelector(config.gridSelector);
  const count = grid?.querySelectorAll(config.cardSelector).length ?? 0;

  if (count > 0) {
    summary.hidden = true;
    return;
  }

  const countEl = summary.querySelector<HTMLElement>('[data-range-summary-count]');
  if (countEl) {
    countEl.textContent = formatResultsCount(0);
  }

  summary.hidden = false;
}
